<template>
    <div>
        <div class='noDatabox'>
            <p>
                {{title}}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
        }
    },
    data() {
        return {
            
        }
    },
}
</script>

<style  scoped>
.noDatabox{display: flex;justify-content: center;align-items: center;height:100%;width:100%;position:absolute}
.noDatabox p{color:#323233}
</style>